// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_hd-1";
export var quotedThread = "_hd-0";